var map = {
	"./BuzonPage.vue": [
		198,
		30
	],
	"./EncuestaServiciosPage.vue": [
		199,
		22
	],
	"./EvaluacionDocentePage.vue": [
		200,
		29
	],
	"./LoginPage.vue": [
		95,
		1
	],
	"./doctos-oficiales/ConsultarPage.vue": [
		201,
		21
	],
	"./doctos-oficiales/SolicitarPage.vue": [
		202,
		20
	],
	"./evaluacion-docente/EvaluacionDocentePage.vue": [
		203,
		6
	],
	"./evaluacion-docente/EvaluacionesRealizadasPage.vue": [
		204,
		15
	],
	"./home/HomePage.vue": [
		96,
		0
	],
	"./information/AvanceReticularPage.vue": [
		205,
		19
	],
	"./information/BoletaPage.vue": [
		206,
		28
	],
	"./information/CalificacionesParcialesPage.vue": [
		207,
		27
	],
	"./information/FamiliarPage.vue": [
		208,
		13
	],
	"./information/GestionCursoPage.vue": [
		209,
		26
	],
	"./information/HorarioPage.vue": [
		210,
		18
	],
	"./information/InstrumentacionDidacticaPage.vue": [
		211,
		25
	],
	"./information/KardexPage.vue": [
		212,
		10
	],
	"./information/PersonalPage.vue": [
		213,
		3
	],
	"./information/ResidenciaProfesionalDescargasPage.vue": [
		214,
		17
	],
	"./information/ResidenciaProfesionalPage.vue": [
		215,
		8
	],
	"./information/ServicioSocialDescargasPage.vue": [
		216,
		16
	],
	"./information/ServicioSocialPage.vue": [
		217,
		11
	],
	"./information/ServicioSocialReportesPage.vue": [
		218,
		9
	],
	"./information/SocioeconomicaPage.vue": [
		219,
		5
	],
	"./information/TrabajoPage.vue": [
		220,
		12
	],
	"./inscripciones/EspecialidadPage.vue": [
		97,
		2
	],
	"./inscripciones/ExtraEscolarPage.vue": [
		221,
		7
	],
	"./inscripciones/GruposDisponiblesPage.vue": [
		222,
		24
	],
	"./inscripciones/ReferenciaBancariaPage.vue": [
		223,
		14
	],
	"./inscripciones/ReinscripcionPage.vue": [
		224,
		4
	],
	"./inscripciones/VeranoPage.vue": [
		225,
		23
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 189;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*Page\.vue$
// module id = 189
// module chunks = 32